<div class="container">
  <!--  <div class="no-data">-->
  <!--سيتم اضافة مقتطفات البطولات قريباً  </div>-->

  <div class="video-container">
    <h1>Invitational Tournament Day3 - Final </h1>
    <div class="wide-video">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/NjR7EqMUy3Q?controls=0"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </div>
    <div class="small-videos-container">
      <div class="block">
        <h2>Invitational Tournament Day2</h2>
        <div class="small-video">
          <iframe width="100%" height="150" src="https://www.youtube.com/embed/nuBOUslBk-E?controls=0"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
      <div class="block">
        <h2>Invitational Tournament Day1</h2>
        <div class="small-video">
          <iframe width="100%" height="150" src="https://www.youtube.com/embed/H_kDHTz4Xis?controls=0"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>

</div>
